export const reportRoutes = [
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('./Report.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/reports/vacations',
    name: 'VacationReport',
    component: () => import('./components/VacationReport.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/reports/letters',
    name: 'lettersReports',
    component: () => import('./views/lettersReport.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin'],
    },
  },
]
